<div class="container nested">
  <lib-ad-sponsor-banner
    *ngIf="teamService.getCurrentTeamId()"
    [entityId]="teamService.getCurrentTeamId()"
    [entityType]="entityType"
    [hideHeader]="true">
  </lib-ad-sponsor-banner>
  <lib-content-card-list
    [item]="item"
    [newsType]="newsType">
  </lib-content-card-list>
</div>
